export enum AGENCY_CAPPING_DOWNLOAD_TYPE {
  CURRENT_CAPPING = 'CURRENT_CAPPING',
  SAMPLE_CSV = 'SAMPLE_CSV'
}

export enum FILE_UPLOAD_STATUS {
  VALIDATION_SUCCESS = 'VALIDATION_SUCCESS',
  IDLE = 'IDLE',
  IN_PROGRESS = 'IN_PROGRESS',
  VALIDATION_FAILURE = 'VALIDATION_FAILURE'
}
